import React from 'react';
import { normalizeCommonAttrs } from '../../../utils/normalizeAttributes';

const SliderField = ({ label, value, onChange, min = 0, max = 100, unit = 'px' }) => (
  <div style={{ marginBottom: '12px' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
      <label style={{ fontSize: '11px', fontWeight: '500', color: '#4B5563' }}>
        {label}
      </label>
      <span style={{ fontSize: '11px', fontWeight: '600', color: '#3B82F6' }}>
        {value}{unit}
      </span>
    </div>
    <input
      type="range"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      min={min}
      max={max}
      style={{
        width: '100%',
        height: '6px',
        borderRadius: '3px',
        outline: 'none',
        cursor: 'pointer'
      }}
    />
  </div>
);

const SelectField = ({ label, value, onChange, options }) => (
  <div style={{ marginBottom: '12px' }}>
    <label style={{ 
      display: 'block', 
      fontSize: '11px', 
      fontWeight: '500', 
      marginBottom: '4px',
      color: '#4B5563'
    }}>
      {label}
    </label>
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: '100%',
        padding: '6px 8px',
        fontSize: '12px',
        border: '1px solid #D1D5DB',
        borderRadius: '6px',
        backgroundColor: '#FFFFFF',
        cursor: 'pointer'
      }}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

const CommonAttributesForm = ({ component, onUpdate }) => {
  const handleChange = (field, value) => {
    // Get normalized attrs for updating
    const normalized = normalizeCommonAttrs(component.commonAttrs);
    onUpdate(component.id, {
      commonAttrs: { ...normalized, [field]: value }
    });
  };

  // Normalize attrs for reading - handles both flat and nested structures
  const commonAttrs = normalizeCommonAttrs(component.commonAttrs);

  return (
    <div>
      <div style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
        <h5 style={{ fontSize: '11px', fontWeight: '600', marginBottom: '8px', color: '#6B7280', textTransform: 'uppercase' }}>
          Size & Position
        </h5>
        <SelectField
          label="Width"
          value={commonAttrs.width}
          onChange={(v) => handleChange('width', v)}
          options={[
            { value: '25', label: 'Quarter (25%)' },
            { value: '33', label: 'Third (33%)' },
            { value: '50', label: 'Half (50%)' },
            { value: '66', label: 'Two Thirds (66%)' },
            { value: '75', label: 'Three Quarters (75%)' },
            { value: '100', label: 'Full Width (100%)' },
            { value: 'auto', label: 'Auto' }
          ]}
        />
      </div>

      <div style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
        <h5 style={{ fontSize: '11px', fontWeight: '600', marginBottom: '8px', color: '#6B7280', textTransform: 'uppercase' }}>
          Inner Spacing
        </h5>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          <SliderField
            label="Top"
            value={commonAttrs.paddingTop}
            onChange={(v) => handleChange('paddingTop', v)}
            max={80}
          />
          <SliderField
            label="Bottom"
            value={commonAttrs.paddingBottom}
            onChange={(v) => handleChange('paddingBottom', v)}
            max={80}
          />
          <SliderField
            label="Left"
            value={commonAttrs.paddingLeft}
            onChange={(v) => handleChange('paddingLeft', v)}
            max={80}
          />
          <SliderField
            label="Right"
            value={commonAttrs.paddingRight}
            onChange={(v) => handleChange('paddingRight', v)}
            max={80}
          />
        </div>
      </div>

      <div>
        <h5 style={{ fontSize: '11px', fontWeight: '600', marginBottom: '8px', color: '#6B7280', textTransform: 'uppercase' }}>
          Outer Spacing
        </h5>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          <SliderField
            label="Top"
            value={commonAttrs.marginTop}
            onChange={(v) => handleChange('marginTop', v)}
            max={80}
          />
          <SliderField
            label="Bottom"
            value={commonAttrs.marginBottom}
            onChange={(v) => handleChange('marginBottom', v)}
            max={80}
          />
        </div>
      </div>
    </div>
  );
};

export default CommonAttributesForm;